import React from 'react';
import cn from 'classnames';
import moment from 'moment';

import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';
import SM from 'components/sidebar/appointment/wizard/Wizard.module.scss';
import useTip from 'hooks/useTip.hook';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';

import CN from './WeekColumnHeader.module.scss';

const WeekColumnHeader = ({ addedServices = [], date, dateFormat, dayName, history, oneStylist, salonId }) => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();

  const { val: renderExitModal, yay: showExitModal, nay: closeExitModal } = useTip(false);

  // if editing a booking
  let inEditing = false;

  if (addedServices && addedServices.filter((s) => s.deleted !== true).length > 0) {
    inEditing = true;
  }

  const isToday = moment().format('YYYYMMDD') === dateFormat;

  const handleClick = () => {
    if (inEditing) {
      showExitModal();
    } else if (oneStylist) {
      history.push(`/salon/${salonId}/day/active/${dateFormat}`);
    } else {
      history.push(`/salon/${salonId}/day/${dateFormat}`);
    }
  };

  const contentClasses = cn({
    [CN.columnHeader]: true,
    [CN.isToday]: isToday,
  });

  return (
    <>
      <div
        className={cn({
          [CN.component]: true,
          [CN.dark]: isDarkMode,
          'col-sticky': true,
        })}
        data-bem="WeekColumnHeader"
      >
        <div role="button" tabIndex={0} id={isToday ? 'todayColumn' : null} className={contentClasses} onClick={handleClick}>
          <div>
            <div className={CN.dayName}>{dayName}</div>
            <div className={CN.day}>{isToday ? t('scheduler.weekScheduler.today') : date}</div>
          </div>
        </div>
      </div>
      <SalonModal tag="WeekColumnHeader__modal--exit" isOpen={renderExitModal} withFooter>
        <SalonModal.Body>
          <IconStatus variant="alert" width="lg">
            <Icon variant="alert" width="l1" />
          </IconStatus>
          <div className={SM.modalContent}>
            <div className={SM.modalTitle}>{t('scheduler.weekScheduler.finishBookingModal.title')}</div>
            <span className={SM.modalText} data-bem="WeekColumnHeader__text">
              {t('scheduler.weekScheduler.finishBookingModal.description')}
            </span>
          </div>
        </SalonModal.Body>
        <SalonModal.Footer>
          <Button tag="WeekColumnHeader__button-ok" variant="primaryForce" onClick={closeExitModal}>
            <span className={SM.buttonSpace}>{t('common.buttons.ok')}</span>
          </Button>
        </SalonModal.Footer>
      </SalonModal>
    </>
  );
};

export default WeekColumnHeader;
